export function NotFoundPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '1rem', textAlign: 'center' }}>
      <div style={{ fontSize: '3rem' }}>404</div>
      <div style={{ fontSize: '1.2rem', color: 'var(--text-secondary)' }}>Страница не найдена</div>
    </div>
  );
}
